import script from "./ProjectFilterPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectFilterPanel.vue?vue&type=script&setup=true&lang=js"

import "./ProjectFilterPanel.vue?vue&type=style&index=0&id=15ac2508&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ac2508"]])

export default __exports__